import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { AppDialogModule } from '../dialog';
import { TemplateCardComponent } from '../template-card/template-card.component';
import { CreateFromTemplateComponent } from './create-from-template.component';
import { CreateFromTemplateService } from './create-from-template.service';
import { TemplateComponent } from './template.component';

import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';

const routes: Routes = [
  {
    path: '',
    component: CreateFromTemplateComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    FormsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    MatGridListModule,
    TemplateCardComponent,
    ReactiveFormsModule,
    MatButtonModule,
    GalaxySnackbarModule,
    AppDialogModule,

    GalaxyFormFieldModule,
    GalaxyInputModule,
  ],
  declarations: [CreateFromTemplateComponent, TemplateComponent],
  exports: [RouterModule],
  providers: [CreateFromTemplateService],
})
export class CreateFromTemplateModule {}
